<template>
	<div class="ReSelectMetro">
		<div v-if="typeof CAT_METRO != 'undefined'">
			<!--div class="metro_lines">
				<el-checkbox class="mr-1" :indeterminate="isIndeterminate1" v-model="checkAll1" @change="handleCheckAllChange1">1 линия</el-checkbox>
				<el-checkbox class="mr-1" :indeterminate="isIndeterminate2" v-model="checkAll2" @change="handleCheckAllChange2">2 линия</el-checkbox>
				<el-checkbox class="mr-1" :indeterminate="isIndeterminate3" v-model="checkAll3" @change="handleCheckAllChange3">3 линия</el-checkbox>
				<el-checkbox class="mr-1" :indeterminate="isIndeterminate4" v-model="checkAll4" @change="handleCheckAllChange4">4 линия</el-checkbox>
				<el-checkbox              :indeterminate="isIndeterminate5" v-model="checkAll5" @change="handleCheckAllChange5">5 линия</el-checkbox>
			</div-->
			<div class="metro_chb">
				<el-checkbox-group v-model="value.all">
					<el-checkbox class="col-6 ml-auto mr-auto" v-for="metro in CAT_METRO" :label="metro.id" :key="metro.id">{{metro.name}}</el-checkbox>
				</el-checkbox-group>
			</div>
		</div>
	</div>
</template>

<script>
	import { CheckboxGroup, Checkbox } from 'element-ui';
	export default {
		name: 'ReSelectMetro',
		components: {
			[Checkbox.name]: Checkbox, 
			[CheckboxGroup.name]: CheckboxGroup,
		},
		props: {
			value: {
				type: Object,
				default(){
					return {
						all: [],
					}
				}
			},
			findId: {
				type: String,
				default: '',
			},
		},
		data () {
			return {
				ver: 1,
				CAT_METRO: this.$GVO.cats.CAT_METRO,
				cat_timer: null,
				isIndeterminate1: false,
				isIndeterminate2: false,
				isIndeterminate3: false,
				isIndeterminate4: false,
				isIndeterminate5: false,
				checkAll1: false,
				checkAll2: false,
				checkAll3: false,
				checkAll4: false,
				checkAll5: false,
			}
		},
		computed: {

		},
		methods: {
			handleCheckAllChange1(){},
			handleCheckAllChange2(){},
			handleCheckAllChange3(){},
			handleCheckAllChange4(){},
			handleCheckAllChange5(){},
		},
		created() {
			this.cat_timer = setInterval(() => {
				if (typeof this.$GVO.cats.CAT_METRO != 'undefined') {
					this.CAT_METRO = this.$GVO.cats.CAT_METRO;
					/*
					this.CAT_METRO = {line1: [],line2: [],line3: [],line4: [],line5: []};
					for (let i = 0; i < this.$GVO.cats.CAT_METRO.length; i++) {
						if(this.$GVO.cats.CAT_METRO[i].line == 1){
							this.CAT_METRO.line1.push(this.$GVO.cats.CAT_METRO[i]);
						}else if(this.$GVO.cats.CAT_METRO[i].line == 2){
							this.CAT_METRO.line2.push(this.$GVO.cats.CAT_METRO[i]);
						}else if(this.$GVO.cats.CAT_METRO[i].line == 3){
							this.CAT_METRO.line3.push(this.$GVO.cats.CAT_METRO[i]);
						}else if(this.$GVO.cats.CAT_METRO[i].line == 4){
							this.CAT_METRO.line4.push(this.$GVO.cats.CAT_METRO[i]);
						}else if(this.$GVO.cats.CAT_METRO[i].line == 5){
							this.CAT_METRO.line5.push(this.$GVO.cats.CAT_METRO[i]);
						}
					}
					*/
					clearTimeout(this.cat_timer);
					this.cat_timer = null;
				}
			}, 250);
		}
	}
</script>
<style scoped>
/*
	.metro_lines{
		display: flex;
		align-content: space-between;
		margin-bottom: 15px;
	}
	.metro_lines > * {width: 100%;}

	.metro_chb{
		display: flex;
		align-content: space-between;
	}
	.ReSelectMetro .metro_chb .el-checkbox{width:100%;}
*/
</style>
